/**
 * Client for the feature-flag backend route:
 *   POST /api/feature-flags/evaluate  → { flags: Record<flagKey, boolean> }
 *
 * Evaluation + granting happen entirely server-side (Express + Admin SDK). The
 * client never reads flag config docs (the email allowlist is PII) — it only
 * receives a boolean verdict per flag for the authenticated user.
 */

import { getAuth } from "firebase/auth";
import { firebaseApp } from "../libs/firebase";
import { getSearchApiBaseUrl } from "../design_stream/components/apiConfig";

export type FeatureFlagVerdicts = Record<string, boolean>;

export async function fetchFeatureFlags(): Promise<FeatureFlagVerdicts> {
  const auth = getAuth(firebaseApp);
  if (!auth.currentUser) throw new Error("Not signed in");
  const token = await auth.currentUser.getIdToken();

  const resp = await fetch(`${getSearchApiBaseUrl()}/api/feature-flags/evaluate`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: "{}",
  });

  if (!resp.ok) {
    throw new Error(`feature-flags evaluate failed: ${resp.status}`);
  }
  const data = (await resp.json()) as { flags?: FeatureFlagVerdicts };
  return data.flags ?? {};
}
